// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var RelayEnv = require("../../../../RelayEnv.bs.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var MlsStatusQuery_graphql = require("../../../../__generated__/MlsStatusQuery_graphql.bs.js");

var convertVariables = MlsStatusQuery_graphql.Internal.convertVariables;

var convertResponse = MlsStatusQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = MlsStatusQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, MlsStatusQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, MlsStatusQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(MlsStatusQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(MlsStatusQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(MlsStatusQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(MlsStatusQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

async function queryFn(address, areaId) {
  var val;
  try {
    val = await fetchPromised(RelayEnv.environment, {
          input: {
            address: address,
            areaId: areaId
          }
        }, undefined, undefined);
  }
  catch (raw_e){
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    return {
            TAG: "Error",
            _0: {
              NAME: "REJECTED",
              VAL: e
            }
          };
  }
  var response = val.validatePropertyMlsStatus;
  if (response === undefined) {
    return {
            TAG: "Error",
            _0: "INVALID_RESPONSE"
          };
  }
  if (response.__typename !== "PropertyMlsStatusValidated") {
    return {
            TAG: "Error",
            _0: "INVALID_RESPONSE"
          };
  }
  var mlsStatus = response.mlsStatus;
  if (mlsStatus !== undefined) {
    return {
            TAG: "Ok",
            _0: mlsStatus
          };
  } else {
    return {
            TAG: "Error",
            _0: "INVALID_RESPONSE"
          };
  }
}

exports.Query = Query;
exports.queryFn = queryFn;
/* use Not a pure module */
